export default "__VITE_ASSET__CnRQoyEd__"